import './ellipsis.css';
export var ellipsisCSS = '_1fkk9vq0-2-0-1';